import { api } from '../features/onboarding/api.ts';
import { useSession } from '../state/session.ts';

// The workspaces and organizations the account can open, fetched again whenever a switcher or
// search opens.
export function refreshDirectory() {
  if (!useSession.getState().actor) return;
  void Promise.allSettled([api.myWorkspaces(), api.myOrgs()]).then(([mine, orgs]) => {
    const session = useSession.getState();
    if (mine.status === 'fulfilled' && Array.isArray(mine.value.workspaces))
      session.setWorkspaces(mine.value.workspaces);
    if (orgs.status === 'fulfilled' && Array.isArray(orgs.value.orgs))
      session.setOrgs(orgs.value.orgs);
  });
}
